import {ExtendChildcareFlow} from '../flow'

export const Confirm = () => <ExtendChildcareFlow />
